module.exports = __webpack_public_path__ + "assets/img/join2021_009.99908e67.png";